import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import { search_param, ISelectorDefault, ColumnDefinition } from '../../_types/search';
import TextSelector, {TextSelectorDefaults}  from '../../common/Selector/TextSelector';
import TrueFalseSelector, {TrueFalseSelectorDefaults} from '../../common/Selector/TrueFalseSelector';
import DateBetweenSelector, {DateBetweenSelectorDefaults} from '../../common/Selector/DateBetweenSelector';
import RoleSelector, {RoleSelectorDefaults} from '../../common/Selector/RoleSelector';
import WholeNumberSelector, {WholeNumberDefaults} from '../../common/Selector/WholeNumberSelector';
import OnlyTrueSelector, { OnlyTrueSelectorDefaults } from '../Selector/OnlyTrueSelector';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const SelectorDefaults = (selector_cn: string): ISelectorDefault => {
    switch (selector_cn) {
        case "selector.date_between":
            return DateBetweenSelectorDefaults(selector_cn);
        case "selector.tf":
        case "selector.yn":
            return TrueFalseSelectorDefaults(selector_cn);
        case "selector.onlytrue":
            return OnlyTrueSelectorDefaults(selector_cn);
        case "selector.role":
            return RoleSelectorDefaults(selector_cn);
        case "selector.number_whole":
            return WholeNumberDefaults(selector_cn);
        case "selector.text":
        default:
            return TextSelectorDefaults(selector_cn);
    }
}

const QueryFieldSelector: React.FC<Props> = (prop: Props) => {
//const userState: IUserState = useContext(AuthContext);

/*
selector
field selector (select fields, sorts)
query builder 
results viewer (paging / download)

*/

const factory = () => {
    switch (prop.selector_cn) {
        case "selector.tf":
        case "selector.yn":
            return (<TrueFalseSelector disabled={prop.disabled} onChange={prop.onChange} selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>);
        case "selector.date_between":
            return (<DateBetweenSelector disabled={prop.disabled}  onChange={prop.onChange} selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>)
        case "selector.number_whole":
            return (<WholeNumberSelector disabled={prop.disabled}  onChange={prop.onChange} selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>)
        case "selector.onlytrue":
            return (<OnlyTrueSelector disabled={prop.disabled}  selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>)
        case "selector.role":
            return (<RoleSelector disabled={prop.disabled}  onChange={prop.onChange} selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>)
        case "selector.text":
        default:
            return (<TextSelector disabled={prop.disabled}  onChange={prop.onChange} selector_cn={prop.selector_cn} searchParam={prop.searchParam}/>);
    }
}

return (
    <React.Fragment>
        { factory() }
    </React.Fragment>
)
}

export default QueryFieldSelector;